import { useEffect, useState } from 'react';

import { ProductModel } from '../../model';
import { ProductDetails } from '../ProductDetails/ProductDetails';
import { ProductImage } from '../ProductImage/ProductImage';
import styles from './ProductCard.module.scss';

import { cartStore } from '@/entities/cart/store/cartStore';
import { useDebounce } from '@/shared/hooks/useDebounce';
import { formatPrice } from '@/shared/lib/currency';
import { observer } from '@/shared/lib/signal/observer';
import { AddToCartButton } from '@/shared/ui-kit/AddToCartButton/AddToCartButton';
import { Drawer } from '@/shared/ui-kit/Drawer/Drawer';
import { useToast } from '@/shared/ui-kit/ToastProvider/useToast';

type Props = { product: ProductModel };

export const ProductCard = observer(({ product }: Props) => {
  const { showError } = useToast();
  const [open, setOpen] = useState(false);

  const storeQty = cartStore.getQty(product.id);

  const [qty, setQty] = useState(storeQty);

  useEffect(() => {
    setQty(storeQty);
  }, [storeQty]);
  const debouncedUpdate = useDebounce((nextQty: number) => {
    cartStore.updateQtyByProduct(product.id, nextQty).catch(() => {
      showError('Ошибка изменения количества товара');
    });
  }, 300);

  const handleDecrease = (next: number) => {
    debouncedUpdate(next);
  };

  const handleIncrease = () => {
    setOpen(true);
  };

  return (
    <>
      <div className={styles.container}>
        <ProductImage
          src={product.image}
          onClick={() => setOpen(true)}
          quantity={qty}
        />
        <div className={styles.cardInfo}>
          <div className={styles.productDetails} onClick={() => setOpen(true)}>
            <h1 className={styles.title}>{product.name}</h1>
            <div className={styles.priceWrapper}>
              <h2 className={styles.price}>{formatPrice(product.price)}</h2>
              {product.parameter && (
                <h2 className={styles.unit}>{product.parameter}</h2>
              )}
            </div>
          </div>
          <AddToCartButton
            size="S"
            min={0}
            value={qty}
            onDecrease={handleDecrease}
            onIncrease={handleIncrease}
          />
        </div>
      </div>

      <Drawer open={open} onClose={() => setOpen(false)}>
        <ProductDetails product={product} onClose={() => setOpen(false)} />
      </Drawer>
    </>
  );
});
